import HOST_API from 'constants/HOST_API';
import useFetch from './useFetch';


import React from 'react';
import Recoil from 'recoil';
import CryptoJS from 'crypto-js';

export default function useDoctorGuideSave(props) {
  const onRequest = useFetch(HOST_API, 'V100/doctor/dr-guide/save');

  const requestDoctorGuideSave = React.useCallback((parameters, callback) => {
    const {
      dr_id,
      patient_no,
      guide_time,
      active_guide,
      meal_guide,
      insulin_guide,
      send_yn,
    } = parameters;

    if(!dr_id) return;
    if(!patient_no) return;

    const onReceive = (res) => {
      if (+res.res_code === 200) {
        callback && callback(true, res.data, parameters);
      } else {
        callback && callback(false, { message: res?.res_msg });
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { messgae: '서버에 연결할 수 없습니다.' }, parameters);
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { message: '서버가 응답하지 않습니다.' }, parameters);
      return true;
    };

    onRequest({
      parameters: {
        dr_id,
        patient_no,
        guide_time,
        ...(active_guide ? { active_guide } : {}),
        ...(meal_guide ? { meal_guide } : {}),
        ...(insulin_guide ? { insulin_guide } : {}),
        send_yn,
      },
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      }
    });
  }, [onRequest]);

  const onDoctorGuideSave = React.useCallback((extra = {}, callback) => (parameters = {}) => {
    requestDoctorGuideSave({ ...parameters, ...extra }, callback);
  }, [requestDoctorGuideSave]);

  return {
    requestDoctorGuideSave,
    onDoctorGuideSave,
  };
}
